import { render, staticRenderFns } from "./ChapterPreview.vue?vue&type=template&id=15d2c847&"
import script from "./ChapterPreview.vue?vue&type=script&lang=js&"
export * from "./ChapterPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports